module.exports = __webpack_public_path__ + "img/Button_Spin.292d2351.png";